import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { pathname } from '../../utils/constants/pathname.js'

const ProtectedRoute = ({
  isAllowed,
  redirectPath = pathname.LOGIN,
  children,
}) => {
  if (!isAllowed) {
    // TODO GM2-336: SHOW 403 ERROR PAGE
    return <Navigate to={redirectPath} replace />
  }
  return children || <Outlet />
}

export default ProtectedRoute
